import { render, staticRenderFns } from "./DataClassRow.vue?vue&type=template&id=27698fec&scoped=true&"
import script from "./DataClassRow.vue?vue&type=script&lang=js&"
export * from "./DataClassRow.vue?vue&type=script&lang=js&"
import style0 from "./DataClassRow.vue?vue&type=style&index=0&id=27698fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27698fec",
  null
  
)

export default component.exports